import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from '@unicus/react-ui-kit';
import {
  PACKAGE,
  PACKAGE_FETCH,
  PACKAGE_FETCH_FINISHED
} from './packageActions';

const packageReducer = createResourceReducer(PACKAGE, [], {
  [PACKAGE_FETCH](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: true,
      items: []
    }));
  },

  [PACKAGE_FETCH_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: false,
      items: action.payload.data.result
    }));
  }
});

export default packageReducer;
